import { actionGenerator } from '../../utils/redux/actionGenerator';

export enum ERequestButtonActionTypes {
  ToggleRequestButtonLoading = 'requestButton/TOGGLE_REQUEST_BUTTON_LOADING',
}

export const toggleRequestButtonLoading = actionGenerator<
  ERequestButtonActionTypes.ToggleRequestButtonLoading,
  boolean
>(ERequestButtonActionTypes.ToggleRequestButtonLoading);

export type TRequestButtonActions = ReturnType<typeof toggleRequestButtonLoading>;
